import { Component } from '@angular/core';

@Component({
  selector: 'app-legal-footer',
  standalone: true,
  imports: [],
  templateUrl: './legal-footer.component.html',
  styleUrl: './legal-footer.component.scss',
})
export class LegalFooterComponent {
  readonly links = [
    { label: 'Impressum', url: 'https://www.keck-atlas.de/system/impressum' },
    { label: 'Datenschutz', url: 'https://www.keck-atlas.de/system/datenschutz' },
  ];
}
